import { Layer, LayerProps } from 'shared/map-exports';
import { useMapLayersState } from 'state/useMapLayersState';
import { getWatchdutyTileUrl } from 'features/mapping/components/layers/layers.utils';
import { addVisible } from 'shared/addVisible';
import { MapLayerProps } from 'features/mapping/mapping.types';
import { ON_TOP_OF_EVERYTHING_LAYER_ID } from 'features/mapping/styles';
import { VisibilityToggledSource } from '../VisibilityToggledSource';

const noCoverageFillStyle = (isDark: boolean): LayerProps => ({
  id: 'radar-no-coverage-fill',
  type: 'fill',
  'source-layer': 'no_coverage',
  paint: {
    'fill-pattern': isDark
      ? 'DiagonalHatchPatternWhite'
      : 'DiagonalHatchPatternBlack',
    'fill-opacity': isDark ? 0.35 : 0.2,
  },
});

const coverageStrokeStyle = (
  sourceLayer: string,
  isDark: boolean,
): LayerProps => ({
  id: `radar-${sourceLayer}-stroke`,
  type: 'line',
  'source-layer': sourceLayer,
  paint: {
    'line-color': isDark ? '#FFFFFF' : '#444444',
    'line-opacity': 0.2,
    'line-width': 1,
  },
});

export const RadarCoverageLayer = ({ visible }: MapLayerProps): JSX.Element => {
  const { isDarkBaseLayer } = useMapLayersState();

  return (
    <VisibilityToggledSource
      url={getWatchdutyTileUrl('radar_coverage')}
      visible={visible}
    >
      <Layer
        beforeId={ON_TOP_OF_EVERYTHING_LAYER_ID}
        {...addVisible(noCoverageFillStyle(isDarkBaseLayer), visible)}
      />
      <Layer
        beforeId={ON_TOP_OF_EVERYTHING_LAYER_ID}
        {...addVisible(
          coverageStrokeStyle('no_coverage', isDarkBaseLayer),
          visible,
        )}
      />
    </VisibilityToggledSource>
  );
};
